export const formatTableTitle = (title: string = ''): string => {
  return title.trim().toLowerCase().replace(/\s+/g, '_');
};
